import { useEffect } from 'react';
import { getSortField, getSortValue, sortKey } from '../../../../../features/table/helpers';
import { defaultViewStyle, viewStyleKey, withArchiveKey } from '../../../../../helpers/path';
import { useLang } from '../../../../../hooks/use-lang';
import { useModalParams } from '../../../../../hooks/use-modal-params';
import { useQueryParams } from '../../../../../hooks/use-query-params';
import { useBranchesStore } from '../../../../../store/use-branch-store';
import { useQrStore } from '../../../../../store/use-qr-store';
import { useTagStaffStore } from '../../../../../store/use-tag-staff-store';
import { SortType } from '../../../../../types/props';

export const useDeviceQrList = () => {
  const { fetchQrList, dynamicList, restoreQrCode, deleteQrCode } = useQrStore();
  const { fetchBranches } = useBranchesStore();
  const { fetchTags } = useTagStaffStore();
  const { t } = useLang();

  const params = useQueryParams().getQueryParams();

  const name = params.name;
  const description = params.description;
  const id = params.id;
  const branchId = params['branch'];
  const isAttached = params['is_attached'];
  const ts = params['ts'];
  const sort = params[sortKey];
  const sortField = getSortField(sort);
  const sortDirection = getSortValue(sort) as SortType;
  const with_archive = !!params[withArchiveKey];
  const viewStyle = params[viewStyleKey] || defaultViewStyle;

  useEffect(() => {
    fetchQrList({
      name,
      description,
      id,
      since_id: 0,
      n: 1000,
      is_by_company: true,
      places: branchId,
      is_attached: isAttached,
      field: sortField,
      dir: sortDirection,
      type: 'AUTH_COMMON_DYNAMIC',
      with_archive,
    });
  }, [branchId, ts, name, description, id, sortField, sortDirection, isAttached, with_archive]);

  useEffect(() => {
    fetchBranches({ since_id: 0, n: 1000 });
    fetchTags({ is_by_company: true, n: 1000, since_id: 0 });
  }, []);

  const viewDynamicQrModal = useModalParams('viewDynamicQr');

  return {
    dynamicList,
    viewDynamicQrModal,
    t,
    restoreQrCode,
    deleteQrCode,
    viewStyle,
  };
};
